
import { useEffect, useState } from 'react';
import { useRetroService } from '../services/retroService';

export function useCreditRequestHistoryList(gridOptions) {
  const [creditRequestHistoryList, setCreditRequestHistoryList] = useState([])
  const { getCreditRequestHistoryList } = useRetroService();

  useEffect(() => {
    (async () => {
      await getCreditRequestHistory();
    })();
  }, [gridOptions]);

  const getCreditRequestHistory = async () => {
    const creditRequestHistoryResponse =  await getCreditRequestHistoryList(gridOptions);
    setCreditRequestHistoryList(creditRequestHistoryResponse)
  }

  return {
    creditRequestHistoryList,
    getCreditRequestHistory
  };
}
